import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import langMsg from '@blade-sxp/search-center/lang/index';
import { fromPage } from '@blade-sxp/search-center/interfaces/enum';
import colors from '@/styles/color.scss';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import DrawWithImg from '@blade/common/components/paint/draw-with-img.vue';
let Details = class Details extends Vue {
    openDetails;
    detailsData;
    detailsIndex;
    detailsRoute;
    showPath;
    loading;
    maxNum;
    sourceImage;
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    multiples = 1;
    layerVal = true;
    count = 0;
    routepage = fromPage.FEATURES_PAGE;
    featuresStr = '';
    image;
    featuresList = [];
    backImageUrl = require('@blade-sxp/search-center/assets/images/back.png');
    nextImageUrl = require('@blade-sxp/search-center/assets/images/right.png');
    routeImageUrl = require('@blade-sxp/search-center/assets/images/route.png');
    fullScreenImgFlag = false;
    maxNums = this.maxNum;
    showAllFeature = false;
    filterImgLv = this.privacyMode === 'true' ? 6 : 0;
    option = {
        normal: {
            fillStyle: '#0077FA',
            globalAlpha: 0.3,
            lineWidth: 2,
            strokeStyle: '#3295FB',
        },
    };
    dataSource = [];
    headPoint = [];
    drawButtons = ['polygon', 'rect'];
    headPointStatus = true;
    imageStyle = {
        width: 800,
        height: 451,
    };
    getCaptureUrl(url) {
        if (url === this.routepage) {
            return this.detailsData?.[this.detailsIndex]?.panoramicUrl;
        }
        return this.detailsData?.[this.detailsIndex]?.captureUrl;
    }
    getDisabled() {
        return (this.detailsData?.[this.detailsIndex]?.portraitImageInPanoramics ?? []).length === 0;
    }
    get showFeaturesList() {
        if (this.showAllFeature)
            return this.featuresList;
        return this.featuresList.slice(0, 10);
    }
    showAllFeatureFn() {
        this.showAllFeature = !this.showAllFeature;
    }
    next() {
        this.$emit('next');
        this.imageUrl(true);
    }
    prev() {
        this.$emit('prev');
        this.imageUrl(true);
    }
    changeSwitch(val) {
        this.drawFace();
    }
    getMaxnum() {
        if (this.maxNums === 50) {
            return true;
        }
        return false;
    }
    imageUrl(val) {
        if (val) {
            this.layerVal = true;
            this.drawFace();
            const detailsData = this.detailsData[this.detailsIndex];
            this.featuresList = [];
            detailsData.features.forEach((item) => {
                this.featuresList.push(`${item.key}/${item.value}`);
            });
            this.featuresStr = this.featuresList.join('、');
            // if (detailsData.checked) {
            //   this.$emit('show', false);
            // } else {
            //   this.$emit('show', true);
            // }
        }
    }
    disabledNum(val) {
        this.maxNums = val;
    }
    drawFace() {
        // 重复获取
        this.$nextTick(() => {
            let url, img;
            if (this.routepage === this.detailsRoute) {
                url = this.detailsData[this.detailsIndex].panoramicUrl;
            }
            else {
                url = this.detailsData[this.detailsIndex].captureUrl;
            }
            // 避免重复请求图片
            if (url === this.image?.url) {
                img = this.image.img;
                this.drawCanvas(img);
            }
            else {
                img = new Image();
                img.src = url;
                this.image = {
                    url,
                    img,
                };
                img.crossOrigin = '';
                // 加载图片
                img.onload = () => {
                    if (img.complete) {
                        this.drawCanvas(img);
                    }
                };
            }
        });
    }
    drawCanvas(img) {
        const canvas = this.$refs.mycanvas;
        if (!canvas) {
            return false;
        }
        // 可以理解为一个画笔，可画路径、矩形、文字、图像
        const context = canvas.getContext('2d');
        // 根据图像重新设定了canvas的长宽
        const { height, width } = img;
        canvas?.setAttribute('width', String(width));
        canvas?.setAttribute('height', String(height));
        // 绘制图片
        context?.drawImage(img, 0, 0, width, height); // 画布大小
        context.lineWidth = 0.01;
        context.strokeStyle = colors.white;
        context.fillStyle = 'transparent';
        const imageData = this.detailsData[this.detailsIndex]?.portraitImageInPanoramics;
        if (imageData && this.layerVal) {
            imageData.forEach((coordinate) => {
                const coordinates = coordinate;
                const x = coordinates.vertices[0].x;
                const y = coordinates.vertices[0].y;
                const rightX = coordinates.vertices[1].x - x;
                const rightY = coordinates.vertices[1].y - y;
                const startX = x * width;
                const startY = y * height;
                const endX = Math.abs(rightX * width);
                const endY = Math.abs(rightY * height);
                context?.strokeRect(startX, startY, endX, endY); // 绘制矩形 X y 长 宽
                context?.fillRect(startX, startY, endX, endY); // 绘制矩形 X y 长 宽
                this.loading = false;
                context.stroke();
                let rectWidth = Math.max(12, endX * 0.2, endY * 0.2);
                rectWidth = Math.min(rectWidth, 35);
                const rectHeight = 5;
                // 绘制4个直角
                context.fillStyle = colors.white;
                context.fillRect(startX, startY, rectWidth, rectHeight);
                context.fillRect(startX, startY, rectHeight, rectWidth);
                context.fillRect(startX, startY + endY - rectWidth, rectHeight, rectWidth);
                context.fillRect(startX, startY + endY - rectHeight, rectWidth, rectHeight);
                context.fillRect(startX + endX - rectWidth, startY, rectWidth, rectHeight);
                context.fillRect(startX + endX - rectHeight, startY, rectHeight, rectWidth);
                context.fillRect(startX + endX - rectHeight, startY + endY - rectWidth, rectHeight, rectWidth);
                context.fillRect(startX + endX - rectWidth, startY + endY - rectHeight, rectWidth, rectHeight);
            });
        }
    }
    closeDetails() {
        this.$emit('close-details');
        this.multiples = 1;
    }
    onFullScreen(type) {
        if (type === 1) {
            this.fullScreenImgFlag = true;
        }
        else {
            this.fullScreenImgFlag = false;
        }
        this.$refs.imgaeScrenn.clickHandler();
        const filterClassName = ['-webkit-filter', '-moz-filter', '-ms-filter', 'filter'];
        this.$nextTick(() => {
            filterClassName.forEach((item) => {
                document.getElementsByClassName('el-image-viewer__canvas')[0].style[item] = `blur(${this.filterImgLv}px)`;
            });
        });
    }
    addRoute(routeData, index) {
        const checkRoute = { ...routeData, checked: true };
        this.$emit('add-route', checkRoute, true, index);
    }
    deleteRoute(routeData, index) {
        const checkRoute = { ...routeData, checked: false };
        this.$emit('deleted-route', checkRoute, false, index);
    }
    handleFullScreen(img) {
        window.open(this.$router.resolve({
            path: img,
        }).href, '_blank');
    }
    toBIgChange() {
        // if (this.multiples >= 1) {
        //   return;
        // }
        this.multiples += 0.25;
    }
    // 缩小
    toSmallChange() {
        if (this.multiples <= 0.3) {
            return;
        }
        this.multiples -= 0.25;
    }
    returnSimilarity(number) {
        let str = '';
        if (number) {
            str = `${(number * 100).toFixed(2)}%`;
        }
        return str;
    }
};
__decorate([
    Prop()
], Details.prototype, "openDetails", void 0);
__decorate([
    Prop()
], Details.prototype, "detailsData", void 0);
__decorate([
    Prop()
], Details.prototype, "detailsIndex", void 0);
__decorate([
    Prop()
], Details.prototype, "detailsRoute", void 0);
__decorate([
    Prop()
], Details.prototype, "showPath", void 0);
__decorate([
    Prop()
], Details.prototype, "loading", void 0);
__decorate([
    Prop()
], Details.prototype, "maxNum", void 0);
__decorate([
    Prop()
], Details.prototype, "sourceImage", void 0);
__decorate([
    Watch('openDetails')
], Details.prototype, "imageUrl", null);
__decorate([
    Watch('maxNum', { deep: true })
], Details.prototype, "disabledNum", null);
Details = __decorate([
    Component({
        name: 'Details',
        components: { BlurPicture, 'darw-width-img': DrawWithImg },
        directives: {
            drag: {
                // 指令的定义
                bind: function (el) {
                    // 获取当前元素
                    let oDiv = el;
                    oDiv.onmousedown = (e) => {
                        // 算出鼠标相对元素的位置
                        let disX = e.clientX - oDiv.offsetLeft;
                        let disY = e.clientY - oDiv.offsetTop;
                        document.onmousemove = (e) => {
                            // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                            let left = e.clientX - disX;
                            let top = e.clientY - disY;
                            oDiv.style.left = left + 'px';
                            oDiv.style.top = top + 'px';
                        };
                        document.onmouseup = () => {
                            document.onmousemove = null;
                            document.onmouseup = null;
                        };
                    };
                },
            },
        },
        i18n: {
            sharedMessages: langMsg,
        },
    })
], Details);
export default Details;
